import { Button, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import PageFooter from 'src/components/PageFooter';
import PageHeader from 'src/components/PageHeader';
import StyledLinearProgressBar from 'src/components/StyledLinearProgressBar';
import TeamMemberAvatar from 'src/components/TeamMemberAvatar';
import { useModalManager } from 'src/components/modals/ModalManager';
import ShareInviteModal from 'src/components/modals/ShareInviteModal';
import { TeamRoles } from 'src/constants/TeamRoles';
import { useOnboardingWorkflow } from 'src/contexts/OnboardingWorkflowContext';
import { getTeamMemberDisplayName } from 'src/utils/nameUtils';

export const Route = createFileRoute('/(app)/onboarding/share-invite')({
    component: ShareInviteComponent,
});

function ShareInviteComponent() {
    const { canGoBack, previousStep, nextStep, progress, invitedTeamMember } =
        useOnboardingWorkflow();
    const { openModal } = useModalManager();

    const handleShareInvite = () => {
        if (!invitedTeamMember) return;

        openModal({
            content: ShareInviteModal,
            props: { teamMember: invitedTeamMember },
        });
    };

    return (
        <>
            <PageHeader
                hideBackButton={!canGoBack}
                onBack={canGoBack ? previousStep : undefined}
                hideActionButton
            >
                <StyledLinearProgressBar value={progress.percentage} />
            </PageHeader>

            <Stack sx={{ gap: 4, mb: 2.5 }}>
                <Typography variant="h1" sx={{ fontWeight: 'bold', whiteSpace: 'balance' }}>
                    Send an invite to{' '}
                    {invitedTeamMember &&
                        getTeamMemberDisplayName(invitedTeamMember, { firstOnly: true })}
                </Typography>

                {invitedTeamMember && (
                    <Stack sx={{ gap: 2, alignItems: 'center' }}>
                        <TeamMemberAvatar
                            teamMember={invitedTeamMember}
                            isLicensedCaregiver={
                                invitedTeamMember.role === TeamRoles.LicensedCaregiver
                            }
                            size="large"
                        />
                        <Stack sx={{ gap: 0.5, alignItems: 'center' }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {getTeamMemberDisplayName(invitedTeamMember)}
                            </Typography>

                            <Typography variant="subtitle2">Pending Invitation</Typography>
                        </Stack>
                    </Stack>
                )}

                <Typography variant="body2">
                    Your new team member can now log in at any time. Text them an invitation to Sage
                    Home to get them started!
                </Typography>
            </Stack>
            <PageFooter>
                <Button variant="text" color="primary" fullWidth onClick={nextStep}>
                    I'm done
                </Button>
                <Button
                    variant="contained"
                    color="primaryInverse"
                    fullWidth
                    onClick={handleShareInvite}
                >
                    Share Invite
                </Button>
            </PageFooter>
        </>
    );
}
